<template>
  <div class="comp-attention">
    <div class="left-dir position-relative md-el-aside" v-resize-width id="attention-tree">
      <tree-list
        v-for="item in TreeArr"
        :key="item.categoryType"
        :ref="item.categoryType"
        :categoryType="item.categoryType"
        @dirChanged="(data, node) => treeDirChange(data, node, item.categoryType)"
        :defaultExpandedKeys="expandedType == item.categoryType && expandedTreeId ? [expandedTreeId] : []"
        :defaultNode="item.defaultNode"
      ></tree-list>
      
      <div style="flex: 1;cursor: auto;"></div>

      <div class="editbtn-view">
        <el-button size="medium" type="primary" @click="isUploadOut = true">上传自有可对外提供服务装备</el-button>
        <el-button size="medium" type="primary" class="att-rec-btn" @click="compRecommOpen">
          <span class="att-rec-btn">推荐优秀外协厂上平台</span>
        </el-button>
      </div>
      
      <el-dialog
        title="上传自有可对外提供服务装备"
        :visible.sync="isUploadOut"
        width="500px"
      >
        <div class="dialog-con">如果您企业拥有制造业相关加工装备，且愿意对其他厂家提供外协服务，则可以通过“大国智造”客户端上传到“大国工匠”外协服务平台，供全国广大工程师选用，提高企业设备利用率，赚取更大加工利润。</div>
        <div class="dialog-con">请点击下方按钮，下载大国智造客户端及相关教程。</div>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="isUploadOut = false">取 消</el-button>
          <el-button size="small" type="primary" @click="_downZip">下载大国智造</el-button>
        </span>
      </el-dialog>
    </div>
    <attention ref="attentionRef"></attention>

    <div class="com-recommd">
      <attention-recommd :recommdTip="recommdTip" @recommdTipChange="recommdTipChange"></attention-recommd>
    </div>

  </div>
</template>

<script>
import {MessageBox,Message} from 'element-ui'
import {WinForm,CheckLibs} from '@digital-supply-chain/module'
import {UtilService} from '@/libs'
import {UserService,OpenService} from '@/service'

import {AutoCreateLectoDir, TreeArrData} from './defaultData'

import TreeList from '@/components/out-tree/tree-list.vue';
import AttentionRecommd from "./attention-recommd.vue";
import Attention from './attention.vue';

const isClient = CheckLibs.isClient();
// 默认展开供应链还是零配件
const expanded = isClient ? WinForm.storge.get(`$attention_expanded_dir_${UserService.userID()}`) : sessionStorage.getItem(`$attention_expanded_dir_${UserService.userID()}`);
let expandSplit = [];
try {
  expandSplit = expanded ? expanded.split(',') : [];
} catch (error) {}
const [expandedType = 'EnterpriseDir', expandedTreeId = 'list_0'] = expandSplit;

export default {
  data() {
    return {
      expandedType,
      expandedTreeId,
      TreeArr: [],
      recommdTip: false,
      isClient,
      isUploadOut: false
    }
  },
  components: { TreeList, AttentionRecommd, Attention },
  mounted() {
    // 设置默认的零配件目录
    // -------------- 如果需要默认就打开这句
    AutoCreateLectoDir();
    
    this.getTreeArr();
  },
  methods: {
    async getTreeArr() {
      const res = await UserService.isOrderMember();
      this.TreeArr = TreeArrData(res.data || false);
      this.$nextTick(() => {
        this.getDefaultCurrent();
      })
    },

    // 默认打开哪个顶级目录
    getDefaultCurrent() {
      try {
        console.log(this.TreeArr)
        this.$refs[this.TreeArr[0].categoryType][0].select(this.expandedTreeId);
      } catch (error) {}
    },

    // 设置下次用户进来后默认展开供应商还是零配件
    setDefaultCurrent(categoryType, treeId) {
      if (!isClient) {
        sessionStorage.setItem(`$attention_expanded_dir_${UserService.userID()}`, `${categoryType},${treeId}`);
        return;
      }
      WinForm.storge.set(`$attention_expanded_dir_${UserService.userID()}`, `${categoryType},${treeId}`);
    },

    treeDirChange(data, node, categoryType) {
      // 设置其他树所有不选中
      this.TreeArr.filter(item => item.categoryType != categoryType).forEach(item => {
        this.$refs[item.categoryType][0].setCurrentNull();
      })
      this.dirChanged(data, node, categoryType);
    },
    dirChanged(data, node, categoryType) {
      if (!categoryType) return;
      // === 当前节点的所有父节点数组 ===
      let parents=[node.data];
      let obj = node;
      while (obj.parent.data && obj.parent.data.DirName){
          parents.push(obj.parent.data);
          obj = obj.parent;
      }
      this.$refs.attentionRef.dirChanged(data.DirID || 0, parents, categoryType);
      this.compRecommClose();
      this.setDefaultCurrent(categoryType, parents[0].TreeID);
    },

    // 我要推荐供应商打开、关闭
    recommdTipChange(bool = undefined) {
			this.recommdTip = bool== undefined ? !this.recommdTip : bool;
		},
    compRecommOpen() {
      this.recommdTipChange(true)
    },
    compRecommClose() {
      this.recommdTipChange(false)
    },

    // 重新计算树DataCount
    dragDataCallback(toId, toDirCategoryId, fromId, fromDirCategoryId, copy = false) {
      // 原始目录的count计算
      let orginData = { toId, fromId };
      const toCategoryType = this.TreeArr.find(item => item.categoryId == toDirCategoryId).categoryType;
      const fromCategoryType = this.TreeArr.find(item => item.categoryId == fromDirCategoryId).categoryType;
      if (copy) {
        delete orginData.fromId;
        this.$refs[toCategoryType][0].dragDataCallback({ toId })
      }
      if (orginData.fromId == 0) {
        this.$refs[toCategoryType][0].dragDataCallback(orginData)
      } else {
        this.$refs[fromCategoryType][0].dragDataCallback(orginData)
      }
    },

    _downZip() {
      WinForm.md.openUrl('https://down.global-dsc.cn/Release/dgzz/dgzz.zip');
      // if (WinForm.md.getAppName() != AppName.BigEngineer && WinForm.md.getAppName() != AppName.BigEngineerE) {
      //     WinForm.md.openUrl('https://down.global-dsc.cn/Release/dgzz/dgzz.exe');
      //     return false;
      // }
      // // WinForm.md.openUrl(`${ApiService.OssHzHost}/kyb/客元宝介绍与帮助.zip`);
      // WinForm.md.openUrl('https://kyb-pack.oss-cn-hangzhou.aliyuncs.com/Release/kyb/KYBmanual.zip');
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--medium {
  padding: 10px 0px;
}
/deep/ .dialog-con {
  line-height: 23px;
  text-indent: 30px;
}
/deep/ .el-dialog__wrapper {
  cursor: auto;
}
.editbtn-view{
  padding: 10px;
  position: sticky;
  bottom: 0;
  background-color: #ffffff;
  border-top: 1px solid @line-strong-color;
  /deep/ .el-button{
    width: 100%;
    margin: 0;
  }
  .att-rec-btn{
    margin-top: 10px;
  }
}
.recommn-btn{
    font-size: 15px;
    text-align: center;
    height: 40px;
    line-height: 40px;
    border-top: 1px solid #F2F2F2;
    color: #ffffff;
    cursor: pointer;
    background-color: #409EFF;
}
.left-dir{
  height: calc(100vh - 20px);
  overflow-y: auto;
  border-right: 6px solid #F2F2F2;
  max-width: 500px;
  min-width: 230px;
  cursor: ew-resize;
  display: flex;
  flex-direction: column;
  /deep/ .tree-span[data-id = "0"] {
    font-weight: bold;
    color: #606266;
  }
  /deep/ .tree-span[data-id = "-1"] {
    font-weight: bold;
    color: #606266;
  }
}
.comp-recommen{
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
}
.com-recommd{
  /deep/ .recommd-comp{
    position: fixed;
    right: 0;
    top: 0;
    height: 100vh;
    background-color: #ffffff;
    /deep/ & > div{
      height: 100%;
    }
  }
}
.comp-attention{
  display: flex;
  flex-direction: row;
  flex: 1;
  background: #ffffff;
  box-shadow: 0px 6px 20px 0px rgba(0, 0, 0, 0.1);
  /deep/ .el-divider--horizontal{
    margin: 0;
  }
}
</style>
